/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class Configuracao {
  constructor () {
    this.configuracao_id = uuidV4()
    this.termos_cadastro = ''
  }
}
